export default __webpack_public_path__ + "static/media/facebook-logo-transparent-white.cb973c99.png";